import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseOneResponse, IGetManyResponse } from '../../shared/model/interface/crud-response-interface.model';
import {
  IFormioRoleCheckerEventPayload,
  IFormioRoleCheckerEventResponse,
  IRoleDataResponse,
} from './formio-role-checker.model';

@Injectable({
  providedIn: 'root',
})
export class FormioRoleCheckerService {
  private readonly URLS = {
    FORMIO_ROLE_CHECKER_EVENT_URL: `${this.baseUrl}/form-submission-check-roles/`,
    ROLES: `${this.baseUrl}/roles/`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public controlFormioRoleChecker(
    params: IFormioRoleCheckerEventPayload,
  ): Observable<IBaseOneResponse<IFormioRoleCheckerEventResponse>> {
    return this.http.post<IBaseOneResponse<IFormioRoleCheckerEventResponse>>(this.URLS.FORMIO_ROLE_CHECKER_EVENT_URL, {
      issuer: params.issuer,
      payload: params.payload,
    });
  }

  public getRoleData(params: HttpParams): Observable<IGetManyResponse<IRoleDataResponse>> {
    return this.http.get<IGetManyResponse<IRoleDataResponse>>(this.URLS.ROLES, { params });
  }

  public getRoleDataParams(): HttpParams {
    return new HttpParams().append('limit', 5000).append('is_active', true).append('ordering', 'name');
  }
}
